import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

// ── Milk Storage Type ────────────────────────────────────────────────────────
export const MilkStorageTypeSchema = z.enum(['REFRIGERATOR', 'FREEZER', 'DEEP_FREEZER']);
export type MilkStorageType = z.infer<typeof MilkStorageTypeSchema>;

// ── POST ──────────────────────────────────────────────────────────────────────
export const CreateStorageLocationRequestSchema = z.object({
  hospital_id: uuidSchema,
  name:        z.string().min(1, 'Name is required').max(200),
  storage_type: MilkStorageTypeSchema.optional(),
});
export type CreateStorageLocationRequest = z.infer<typeof CreateStorageLocationRequestSchema>;

export const CreateStorageLocationResponseSchema = z.object({
  storage_location_id: uuidSchema,
  hospital_id:         uuidSchema,
  name:                z.string(),
  storage_type:        z.string(),
  barcode:             z.string().nullable(),
  is_active:           z.boolean(),
  created_at:          z.string().datetime(),
  updated_at:          z.string().datetime(),
});
export type CreateStorageLocationResponse = z.infer<typeof CreateStorageLocationResponseSchema>;

// ── GET (active) ──────────────────────────────────────────────────────────────
export const ActiveStorageLocationSchema = z.object({
  storage_location_id: uuidSchema,
  hospital_id:         uuidSchema,
  name:                z.string(),
  storage_type:        z.string(),
  barcode:             z.string().nullable(),
  is_active:           z.literal(true),
});
export type ActiveStorageLocation = z.infer<typeof ActiveStorageLocationSchema>;

// ── PATCH status ───────────────────────────────────────────────────────────────
export const UpdateStorageLocationStatusRequestSchema = z.object({
  is_active: z.boolean(),
});
export type UpdateStorageLocationStatusRequest = z.infer<typeof UpdateStorageLocationStatusRequestSchema>;

export const UpdateStorageLocationStatusResponseSchema = z.object({
  storage_location_id: uuidSchema,
  hospital_id:         uuidSchema,
  name:                z.string(),
  storage_type:        z.string(),
  barcode:             z.string().nullable(),
  is_active:           z.boolean(),
  updated_at:          z.string().datetime(),
});
export type UpdateStorageLocationStatusResponse = z.infer<typeof UpdateStorageLocationStatusResponseSchema>;
